import { useEffect, useState, useRef } from "react";
import { Button, Form, Alert, Image, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Validation from "../../../hooks/Validation";
import { createUpdateClient } from "../../../store/actions/clientsAction";
import { resetPopup, userReset } from "../../../store/reducerSlice/clients";
import AlertMessage from "./AlertMessage";
import Popup from "../../common/modal/Popup";
import { fetchLocationList } from "../../../store/actions/locationsAction";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";

const formElements = [
  {
    key: "locations",
    label: "Geography",
    placeHolder: "Select geography",
    type: "select",
    options: [],
  },
  {
    key: "wardTypes",
    label: "Ward Type",
    placeHolder: "Select ward",
    type: "select",
    options: [
      "Frailty Virtual",
      "Respiratory Virtual",
      "Physical Ward",
      "Heart Failure Virtual",
      "UCRT",
      "IMC-STROKE"
    ],
  },
  {
    key: "contactName",
    label: "Admin Contact Name",
    placeHolder: "Enter contact person name",
    type: "text",
  },
  {
    key: "clientEmail",
    label: "Admin Email",
    placeHolder: "Enter admin email",
    type: "text",
  },
];

const ManageClient = (props) => {
  const { selectclient } = props;
  const adminDetail = props.adminDetail;
  // Accessing wardTypes from adminDetail
  const wardTypes = adminDetail?.wardTypes;
  const locationTypes = adminDetail?.locations;

  const [isUploading, setIsUploading] = useState(false);
  const [logo, setLogo] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [alertModalShow, setAlertModalShow] = useState(false);
  const inputRef = useRef();
  const [locationOptions, setLocationOptions] = useState(null);

  const [selectedWardType, setSelectedWardType] = useState("");

  const [clientDetail, setClientDetail] = useState({
    locations: null,
    wardTypes: null,
    contactName: null,
    clientEmail: null,
  });
  const { locations } = useSelector((state) => {
    return state.locations;
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation({
      locations: clientDetail?.locations,
      wardTypes:clientDetail?.wardTypes,
      contactName: clientDetail?.contactName,
      clientEmail: clientDetail?.clientEmail,
    });
  const dispatch = useDispatch();
  const {
    isRecordAdded,
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => state.clients);

  useEffect(() => {
    if (!Array.isArray(locations)) {
      dispatch(fetchLocationList());
    }
  }, []);

  useEffect(() => {
    if (Array.isArray(locations)) {
      let arr = locations.map((x) => {
        return { _id: x._id, name: x?.name };
      });
      setLocationOptions(arr);
    }
  }, [locations]);


  useEffect(() => {
    if (selectclient === null) {
      setClientDetail({
        locations: null,
        contactName: null,
        clientEmail: null,
        wardTypes: null,
      });
      setLogoUrl(null);
    } else {
      const map1 = selectclient?.locations?.map((x) => x._id);
      const map2 = selectclient?.wardTypes?.map((x) => x);
      setClientDetail({
        clientId: selectclient?._id,
        contactName: selectclient?.contactName,
        clientEmail: selectclient?.clientEmail,
        locations: map1,
        wardTypes: map2,
      });
    }
  }, [selectclient]);

  const submitHandler = (e) => {
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (clientDetail?.wardTypes === "None") {
      // Update the wardTypes property using setClientDetail
      setClientDetail({
        ...clientDetail,
        wardTypes: null,
      });

      setAlertModalShow(true);
    }
  }, [clientDetail?.wardTypes]);
  useEffect(() => {
    setIsUploading(true);

    let formData = {
      clientId: clientDetail?.clientId,
      contactName: clientDetail?.contactName,
      clientEmail: clientDetail?.clientEmail,
      locations: clientDetail?.locations,

      wardTypes: clientDetail?.wardTypes ? clientDetail?.wardTypes : [],
    };

    if (!isError() && error !== null && isActionCalled) {
      dispatch(createUpdateClient(formData)).then(({ payload }) => {
        if (payload.success) {
          setIsUploading(true);
          hideHandler();
        } else {
          setIsShow(true);
        }
      });
      setIsActionCalled(false);
    } else {
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandler = () => {
    resetAllValidator();
    props.onHide();

    if (selectclient === null) {
      setClientDetail({
        locations: null,
        contactName: null,
        clientEmail: null,
        wardTypes: null,
      });
    } else {
      // let map1 = null;
      // let map2 = null;
      // if (wardTypes && wardTypes.length > 0) {
      //   map2 = wardTypes?.map((x) => x);
      // } else {
      //   map2 = selectclient?.wardTypes?.map((x) => x);
      // }
      // if (locationTypes && locationTypes.length > 0) {
      //   map1 = locationTypes?.map((x) => x);
      // } else {
      //   map1 = selectclient?.wardTypes?.map((x) => x);
      // }
      const map1 = selectclient?.locations?.map((x) => x._id);
      const map2 = selectclient?.wardTypes?.map((x) => x);
      setClientDetail({
        clientId: selectclient?._id,
        contactName: selectclient?.contactName,
        clientEmail: selectclient?.clientEmail,
        locations: map1,
        wardTypes: map2,
      });
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };
  const hideHandle = () => {
    setAlertModalShow(false);
  };

  const { onHide, ...props1 } = props;

  return (
    <>
      <AlertMessage
        onHide={hideHandle}
        alertModalShow={alertModalShow}
        setAlertModalShow={setAlertModalShow}
      />

      <Popup
        {...props1}
        onHide={hideHandler}
        size="md"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectclient ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        {formElements.map((element, i) => {
          return (
            (!selectclient || element.key !== "password") && (
              <Form.Group className="mb-4" controlId="formBasicEmail" key={i}>
                <Form.Label>
                  {element.label}{" "}
                  
                    <span className="required">*</span>
                 
                </Form.Label>
                {element.type === "select" ? (
                  <>
                    <Form.Select
                      style={{ textTransform: "capitalize" }}
                      name={element.key}
                      value={
                        clientDetail && clientDetail?.[element.key] === null
                          ? []
                          : clientDetail?.[element.key]
                      }
                      multiple
                      onChange={(e) => {
                        let selected = [];
                        for (var option of e.target.options) {
                          if (option.selected) {
                            if (option.value === "none") {
                              selected = ["none"];
                              break;
                            } else {
                              selected.push(option.value);
                            }
                          }
                        }
                       
                        setClientDetail({
                          ...clientDetail,
                          [element.key]: selected.length ? selected : null,
                        });

                        resetValidator(e.target.name);
                      }}
                      onDoubleClick={(e) => {
                        if (e.target.value === "none") {
                          setClientDetail({
                            ...clientDetail,
                            [element.key]: "null",
                          });
                        }
                      }}
                      isInvalid={error && error[element.key]}
                    >
                      <option style={{ display: "none" }} value="">
                        Select
                      </option>

                      {element.key === "locations" && locationTypes
                        ? locationTypes.map((item) => (
                            // <option value={JSON.stringify(item)}>{item.name}</option>
                            <option
                              style={{ padding: "2px 0px" }}
                              value={item._id}
                            >
                              {item.name}
                            </option>
                          ))
                        : element.key === "locations" && locationOptions
                        ? locationOptions.map((item) => (
                            // <option value={JSON.stringify(item)}>{item.name}</option>
                            <option
                              style={{ padding: "2px 0px" }}
                              value={item._id}
                            >
                              {item.name}
                            </option>
                          ))
                        : element.key === "wardTypes" && wardTypes
                        ? [
                            ...wardTypes.map((item) => (
                              <option
                                style={{ padding: "2px 0px" }}
                                value={item}
                              >
                                {item}
                              </option>
                            )),
                            !wardTypes.includes("none") && (
                              <option value="none" key="none">
                                None
                              </option>
                            ),
                          ]
                        : element.key === "wardTypes" && element.options
                        ? [
                            ...element.options.map((item) => (
                              <option
                                style={{ padding: "2px 0px" }}
                                value={item}
                              >
                                 {item.replace("IMC-STROKE", "IMC/STROKE")}
                              </option>
                            )),
                            <option value="none">None</option>,
                          ]
                        :
                        element.options.map((item) => (
                            <option style={{ padding: "2px 0px" }} value={item}>
                              {" "}
                              {item}{" "}
                            </option>
                          ))}
                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      {element.key === "locations" && <> Please select a geography </>  }
                      {element.key === "wardTypes" && <> Please select a ward type </>  }
                    </Form.Control.Feedback>
                    {clientDetail && clientDetail?.locations?.length ? (
                      <div
                        className="requiredNote"
                        style={{ marginTop: 10, position: "absolute" }}
                      >
                        Hint: Please press ctrl key to select multiple options.
                      </div>
                    ) : null}
                  </>
                ) : (
                  <>
                    <Form.Control
                      type={element.type}
                      name={element.key}
                      placeholder={element.placeHolder}
                      value={clientDetail && clientDetail[element.key]}
                      disabled={selectclient && element.key === "clientEmail"}
                      onChange={(e) => {
                        setClientDetail({
                          ...clientDetail,
                          [element.key]: e.target.value,
                        });
                        resetValidator(e.target.name);
                      }}
                      isInvalid={error && error[element.key]}
                    />
                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                    {element.key === "contactName" ? (
                      <>
                        {clientDetail && clientDetail?.contactName?.length ? (
                          <div
                            className="requiredNote"
                            style={{ marginTop: "4px", position: "absolute" }}
                          >
                            Note: Minimum 3 characters are required.
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </>
                )}
              </Form.Group>
            )
          );
        })}

        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded: isShow,
            title: selectclient ? "Update Admin" : "Add Admin",
            successMsg: successMessage,
            errorRes: apiError?.message,
          }}
        />
      </Popup>
    </>
  );
};

export default ManageClient;
